// React Query `retry` for reads: a refusal answers the same again, an outage may not.
import { ApiError } from './client'

/** A 4xx the same request gets again: not a timeout (408) or a rate limit (429). */
function isRefusal(error: unknown): boolean {
  if (!(error instanceof ApiError)) return false
  return error.status >= 400 && error.status < 500 && error.status !== 408 && error.status !== 429
}

/** Two more tries for anything but a refusal (not a member, an unknown case …). */
export function retryUnlessRefused(failureCount: number, error: unknown): boolean {
  return !isRefusal(error) && failureCount < 2
}
